import React from "react";
import type { DeliveryFormat, Platform } from "./types";
import { rawColors } from "../../../design-system/tokens/colors";

export const SlackIcon: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M13.2501 7.4998C13.9404 7.4998 14.5 6.9402 14.5 6.2499C14.5 5.5596 13.9403 5 13.25 5C12.5597 5 12 5.55965 12 6.25V7.4998H13.2501ZM9.75 7.4998C10.4404 7.4998 11 6.94015 11 6.2498V2.75C11 2.05965 10.4404 1.5 9.75 1.5C9.05965 1.5 8.5 2.05965 8.5 2.75V6.2498C8.5 6.94015 9.05965 7.4998 9.75 7.4998Z"
      fill="#2EB67D"
    />
    <path
      d="M2.7499 8.5C2.0596 8.5 1.5 9.0596 1.5 9.7499C1.5 10.4402 2.05965 10.9998 2.74994 10.9998C3.4403 10.9998 4 10.4401 4 9.7498V8.5H2.7499ZM6.25 8.5C5.55965 8.5 5 9.05965 5 9.75V13.2498C5 13.9401 5.55965 14.4998 6.25 14.4998C6.94035 14.4998 7.5 13.9401 7.5 13.2498V9.75C7.5 9.05965 6.94035 8.5 6.25 8.5Z"
      fill="#E01E5A"
    />
    <path
      d="M8.5 13.2501C8.5 13.9404 9.0596 14.5 9.7499 14.5C10.4402 14.5 10.9998 13.9403 10.9998 13.25C10.9998 12.5597 10.4401 12 9.7498 12H8.5V13.2501ZM8.5 9.75C8.5 10.4404 9.05965 11 9.75 11H13.2498C13.9401 11 14.4998 10.4404 14.4998 9.75C14.4998 9.05965 13.9401 8.5 13.2498 8.5H9.75C9.05965 8.5 8.5 9.05965 8.5 9.75Z"
      fill="#ECB22E"
    />
    <path
      d="M7.4998 2.7499C7.4998 2.0596 6.9402 1.5 6.2499 1.5C5.5596 1.5 5 2.05965 5 2.74994C5 3.4403 5.55965 4 6.25 4H7.4998V2.7499ZM7.4998 6.25C7.4998 5.55965 6.94015 5 6.2498 5H2.75C2.05965 5 1.5 5.55965 1.5 6.25C1.5 6.94035 2.05965 7.5 2.75 7.5H6.2498C6.94015 7.5 7.4998 6.94035 7.4998 6.25Z"
      fill="#36C5F0"
    />
  </svg>
);

export const GmailIcon: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M1 5.9778C1 4.23539 1 3.3642 1.33909 2.69869C1.63736 2.1133 2.1133 1.63736 2.69869 1.33909C3.3642 1 4.23539 1 5.9778 1H10.0222C11.7646 1 12.6358 1 13.3013 1.33909C13.8867 1.63736 14.3626 2.1133 14.6609 2.69869C15 3.3642 15 4.23539 15 5.9778V10.0222C15 11.7646 15 12.6358 14.6609 13.3013C14.3626 13.8867 13.8867 14.3626 13.3013 14.6609C12.6358 15 11.7646 15 10.0222 15H5.9778C4.23539 15 3.3642 15 2.69869 14.6609C2.1133 14.3626 1.63736 13.8867 1.33909 13.3013C1 12.6358 1 11.7646 1 10.0222V5.9778Z"
      fill="white"
    />
    <path
      d="M11.0243 4.26172L8.03074 6.59794L4.96875 4.26172V4.26235L4.97245 4.26551V7.53684L7.99624 9.92354L11.0243 7.62899V4.26172Z"
      fill="#EA4335"
    />
    <path
      d="M11.8135 3.69319L11.0273 4.26146V7.62875L13.5011 5.7295V4.58537C13.5011 4.58537 13.2008 2.95129 11.8135 3.69319Z"
      fill="#FBBC05"
    />
    <path
      d="M11.0273 7.62972V11.9972H12.9233C12.9233 11.9972 13.4629 11.9416 13.5017 11.3266V5.73047L11.0273 7.62972Z"
      fill="#34A853"
    />
    <path
      d="M4.97259 11.9998V7.53635L4.96875 7.5332L4.97259 11.9998Z"
      fill="#C5221F"
    />
    <path
      d="M4.97007 4.26227L4.18823 3.69716C2.8009 2.95525 2.5 4.58871 2.5 4.58871V5.7328L4.97007 7.5336V4.26227Z"
      fill="#C5221F"
    />
    <path
      d="M4.96875 4.26172V7.53306L4.97259 7.53621V4.26488L4.96875 4.26172Z"
      fill="#C5221F"
    />
    <path
      d="M2.5 5.73438V11.3305C2.53823 11.9462 3.07837 12.0011 3.07837 12.0011H4.97438L4.97007 7.53452L2.5 5.73438Z"
      fill="#4285F4"
    />
  </svg>
);

export const TeamsIcon: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M10.7644 6.87578H14.3804C14.7224 6.87578 14.9994 7.15178 14.9994 7.49278V10.7808C14.9991 11.0791 14.9401 11.3745 14.8257 11.6501C14.7113 11.9256 14.5437 12.176 14.3325 12.3867C14.1214 12.5975 13.8708 12.7647 13.595 12.8786C13.3193 12.9925 13.0238 13.051 12.7254 13.0508H12.7154C12.417 13.051 12.1215 12.9925 11.8458 12.8786C11.57 12.7647 11.3194 12.5975 11.1083 12.3867C10.8971 12.176 10.7295 11.9256 10.6151 11.6501C10.5007 11.3745 10.4417 11.0791 10.4414 10.7808V7.19978C10.4414 7.02078 10.5864 6.87578 10.7644 6.87578ZM13.2094 6.22578C14.0174 6.22578 14.6734 5.57078 14.6734 4.76378C14.6734 3.95578 14.0174 3.30078 13.2084 3.30078C12.3994 3.30078 11.7434 3.95578 11.7434 4.76378C11.7434 5.57078 12.3994 6.22578 13.2084 6.22578H13.2094Z"
      fill="#5059C9"
    />
    <path
      d="M8.65117 6.225C8.92887 6.2254 9.20392 6.17108 9.46062 6.06514C9.71732 5.9592 9.95063 5.80373 10.1472 5.6076C10.3438 5.41147 10.4998 5.17852 10.6064 4.92208C10.7129 4.66563 10.7679 4.3907 10.7682 4.113C10.768 3.83514 10.7131 3.56002 10.6066 3.30339C10.5 3.04677 10.3439 2.81366 10.1472 2.61741C9.95051 2.42116 9.71704 2.26562 9.46016 2.15968C9.20328 2.05374 8.92803 1.99948 8.65017 2C8.37255 1.99974 8.09761 2.05416 7.84102 2.16016C7.58444 2.26615 7.35125 2.42165 7.15476 2.61777C6.95827 2.81388 6.80233 3.04678 6.69585 3.30316C6.58937 3.55955 6.53443 3.83439 6.53417 4.112C6.53417 5.279 7.48117 6.225 8.65017 6.225H8.65117ZM11.4732 6.875H5.50317C5.34128 6.87894 5.18758 6.94697 5.07582 7.06416C4.96407 7.18135 4.90341 7.33811 4.90717 7.5V11.25C4.88543 12.222 5.25035 13.1628 5.92177 13.8659C6.5932 14.569 7.51624 14.9769 8.48817 15C9.46027 14.9772 10.3836 14.5694 11.0552 13.8663C11.7268 13.1631 12.0919 12.2221 12.0702 11.25V7.5C12.072 7.41976 12.0581 7.33994 12.0291 7.2651C12.0001 7.19025 11.9566 7.12186 11.9012 7.06382C11.8457 7.00577 11.7794 6.95923 11.7059 6.92683C11.6325 6.89443 11.5534 6.87682 11.4732 6.875Z"
      fill="#7B83EB"
    />
    <path
      opacity="0.1"
      d="M8.81441 6.875V12.13C8.81362 12.2877 8.75055 12.4388 8.63892 12.5502C8.52729 12.6617 8.37615 12.7245 8.21841 12.725H5.19341C5.00414 12.2559 4.90671 11.7548 4.90641 11.249V7.5C4.90456 7.41981 4.91853 7.34003 4.94754 7.26525C4.97655 7.19046 5.02003 7.12213 5.07548 7.06417C5.13094 7.00621 5.19728 6.95975 5.27071 6.92747C5.34414 6.89518 5.42322 6.87769 5.50341 6.876H8.81341L8.81441 6.875Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M8.48641 6.87405V12.454C8.4851 12.6116 8.42186 12.7624 8.31034 12.8737C8.19883 12.985 8.04799 13.048 7.89041 13.049H5.34541C5.23297 12.8428 5.14344 12.6248 5.07841 12.399C4.96468 12.0263 4.90672 11.6388 4.90641 11.249V7.49705C4.90455 7.41694 4.9185 7.33724 4.94745 7.26252C4.9764 7.1878 5.01978 7.11951 5.07513 7.06157C5.13048 7.00362 5.1967 6.95714 5.27002 6.9248C5.34333 6.89245 5.4223 6.87486 5.50241 6.87305H8.48741L8.48641 6.87405Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M8.48641 6.87405V11.804C8.4851 11.9616 8.42186 12.1124 8.31034 12.2237C8.19883 12.335 8.04799 12.398 7.89041 12.399H5.07841C4.96468 12.0263 4.90672 11.6388 4.90641 11.249V7.49705C4.90455 7.41694 4.9185 7.33724 4.94745 7.26252C4.9764 7.1878 5.01978 7.11951 5.07513 7.06157C5.13048 7.00362 5.1967 6.95714 5.27002 6.9248C5.34333 6.89245 5.4223 6.87486 5.50241 6.87305H8.48741L8.48641 6.87405Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M8.16241 6.87405V11.804C8.1611 11.9616 8.09786 12.1124 7.98634 12.2237C7.87483 12.335 7.72399 12.398 7.56641 12.399H5.07841C4.96468 12.0263 4.90672 11.6388 4.90641 11.249V7.49705C4.90455 7.41694 4.9185 7.33724 4.94745 7.26252C4.9764 7.1878 5.01978 7.11951 5.07513 7.06157C5.13048 7.00362 5.1967 6.95714 5.27002 6.9248C5.34333 6.89245 5.4223 6.87486 5.50241 6.87305L8.16241 6.87405Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M8.81475 5.19461V6.21861C8.75975 6.22161 8.70775 6.22461 8.65175 6.22461C8.59675 6.22461 8.54475 6.22161 8.48875 6.21861C8.04214 6.18419 7.61799 6.00887 7.27743 5.7179C6.93687 5.42694 6.69747 5.03537 6.59375 4.59961H8.21875C8.37631 4.60013 8.5273 4.66282 8.6389 4.77405C8.7505 4.88527 8.8137 5.03605 8.81475 5.19361V5.19461Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M8.48922 5.51978V6.21878C8.1007 6.18906 7.72795 6.05259 7.41208 5.82443C7.09622 5.59626 6.84952 5.28528 6.69922 4.92578H7.89422C8.05161 4.92657 8.20234 4.98937 8.31373 5.10057C8.42511 5.21177 8.48817 5.36239 8.48922 5.51978Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M8.48922 5.51978V6.21878C8.1007 6.18906 7.72795 6.05259 7.41208 5.82443C7.09622 5.59626 6.84952 5.28528 6.69922 4.92578H7.89422C8.05161 4.92657 8.20234 4.98937 8.31373 5.10057C8.42511 5.21177 8.48817 5.36239 8.48922 5.51978Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M8.16422 5.52078V6.16778C7.83934 6.09106 7.53723 5.93853 7.28261 5.72266C7.02798 5.5068 6.82807 5.23373 6.69922 4.92578H7.56922C7.72678 4.92657 7.87766 4.98951 7.98908 5.10092C8.10049 5.21234 8.16343 5.36322 8.16422 5.52078Z"
      fill="black"
    />
    <path
      d="M1.597 4.92578H7.566C7.896 4.92578 8.163 5.19278 8.163 5.52178V11.4798C8.163 11.5581 8.14755 11.6357 8.11754 11.7081C8.08752 11.7805 8.04353 11.8462 7.98808 11.9016C7.93263 11.9569 7.86681 12.0008 7.79439 12.0307C7.72196 12.0606 7.64435 12.0759 7.566 12.0758H1.596C1.51773 12.0758 1.44023 12.0604 1.36792 12.0304C1.29561 12.0005 1.22991 11.9566 1.17456 11.9012C1.11922 11.8459 1.07532 11.7802 1.04537 11.7079C1.01542 11.6356 1 11.558 1 11.4798V5.52178C1 5.19178 1.267 4.92578 1.597 4.92578Z"
      fill="url(#paint0_linear_977_101598)"
    />
    <path
      d="M6.15372 7.1925H4.96072V10.4355H4.20072V7.1925H3.01172V6.5625H6.15272L6.15372 7.1925Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_977_101598"
        x1="2.244"
        y1="4.46078"
        x2="6.906"
        y2="12.5488"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5A62C3" />
        <stop offset="0.5" stop-color="#4D55BD" />
        <stop offset="1" stop-color="#3940AB" />
      </linearGradient>
    </defs>
  </svg>
);

export const PlatformIcon: React.FC<{ platform: Platform; size?: number }> = ({
  platform,
  size,
}) => {
  switch (platform) {
    case "slack":
      return <SlackIcon size={size} />;
    case "email":
      return <GmailIcon size={size} />;
    case "teams":
      return <TeamsIcon size={size} />;
  }
};

export const PRESENTATION_ICON = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <rect x="2.5" y="3.5" width="15" height="10" rx="1" />
    <path d="M10 13.5V17M7 17h6" />
  </svg>
);

export const PDF_ICON = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M4 2.5h7l5 5V17a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1Z" />
    <path d="M11 2.5v5h5" />
    <text
      x="10"
      y="15"
      textAnchor="middle"
      fontFamily="Arial, sans-serif"
      fontSize="5"
      fontWeight="700"
      stroke="none"
      fill="currentColor"
    >
      PDF
    </text>
  </svg>
);

export const VIDEO_ICON = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <rect x="2" y="5" width="11" height="10" rx="1" />
    <path d="m13 9 5-3v8l-5-3Z" />
  </svg>
);

export const IMAGE_SET_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M12.082 1.66602H4.9987C4.55667 1.66602 4.13275 1.84161 3.82019 2.15417C3.50763 2.46673 3.33203 2.89065 3.33203 3.33268V16.666C3.33203 17.108 3.50763 17.532 3.82019 17.8445C4.13275 18.1571 4.55667 18.3327 4.9987 18.3327H14.9987C15.4407 18.3327 15.8646 18.1571 16.1772 17.8445C16.4898 17.532 16.6654 17.108 16.6654 16.666V6.24935L12.082 1.66602Z"
      stroke={rawColors.text.mediumEmphasis}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.668 1.66602V6.66602H16.668"
      stroke={rawColors.text.mediumEmphasis}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33464 12.4993C9.25511 12.4993 10.0013 11.7532 10.0013 10.8327C10.0013 9.91221 9.25511 9.16602 8.33464 9.16602C7.41416 9.16602 6.66797 9.91221 6.66797 10.8327C6.66797 11.7532 7.41416 12.4993 8.33464 12.4993Z"
      stroke={rawColors.text.mediumEmphasis}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.6654 14.1664L15.757 13.2581C15.4448 12.9477 15.0223 12.7734 14.582 12.7734C14.1417 12.7734 13.7193 12.9477 13.407 13.2581L8.33203 18.3331"
      stroke={rawColors.text.mediumEmphasis}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SparkleIcon: React.FC<{ size?: number }> = ({ size = 14 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
  >
    <g
      clip-path="url(#paint0_diamond_982_106300_clip_path)"
      data-figma-skip-parse="true"
    >
      <g transform="matrix(-0.00420554 -0.00332191 0.00200973 -0.0069514 8.43088 5.04438)">
        <rect
          x="0"
          y="0"
          width="1417.56"
          height="1137.38"
          fill="url(#paint0_diamond_982_106300)"
          opacity="1"
          shape-rendering="crispEdges"
        />
        <rect
          x="0"
          y="0"
          width="1417.56"
          height="1137.38"
          transform="scale(1 -1)"
          fill="url(#paint0_diamond_982_106300)"
          opacity="1"
          shape-rendering="crispEdges"
        />
        <rect
          x="0"
          y="0"
          width="1417.56"
          height="1137.38"
          transform="scale(-1 1)"
          fill="url(#paint0_diamond_982_106300)"
          opacity="1"
          shape-rendering="crispEdges"
        />
        <rect
          x="0"
          y="0"
          width="1417.56"
          height="1137.38"
          transform="scale(-1)"
          fill="url(#paint0_diamond_982_106300)"
          opacity="1"
          shape-rendering="crispEdges"
        />
      </g>
    </g>
    <path
      d="M9.6896 3.43888C8.84707 2.64562 8.27039 1.26039 7.9842 0C7.69757 1.26064 7.12151 2.64617 6.27867 3.43943C5.43614 4.23214 3.96389 4.7749 2.625 5.04479C3.96443 5.31415 5.43642 5.85658 6.27894 6.64987C7.12147 7.44284 7.69815 8.82837 7.98478 10.0888C8.27097 8.82811 8.84748 7.44258 9.68987 6.64933C10.5324 5.85636 12.0047 5.31386 13.3435 5.04396C12.0044 4.77461 10.5324 4.23188 9.6896 3.43888Z"
      data-figma-gradient-fill='{"type":"GRADIENT_DIAMOND","stops":[{"color":{"r":0.66666668653488159,"g":0.59215688705444336,"b":0.84705883264541626,"a":1.0},"position":0.0},{"color":{"r":0.39215686917304993,"g":0.25882354378700256,"b":0.70196080207824707,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.66666668653488159,"g":0.59215688705444336,"b":0.84705883264541626,"a":1.0},"position":0.0},{"color":{"r":0.39215686917304993,"g":0.25882354378700256,"b":0.70196080207824707,"a":1.0},"position":1.0}],"transform":{"m00":-8.4110765457153320,"m01":4.0194535255432129,"m02":10.626687049865723,"m10":-6.6438117027282715,"m11":-13.902793884277344,"m12":15.317678451538086},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    />
    <path
      d="M5.09547 9.92945C4.59255 9.45589 4.24747 8.62789 4.07651 7.875C3.90523 8.62789 3.56132 9.45585 3.05785 9.9297C2.55438 10.403 1.6748 10.7275 0.875 10.8887C1.67508 11.0499 2.55438 11.3739 3.05785 11.8477C3.56132 12.3213 3.90585 13.1493 4.07709 13.9022C4.24802 13.149 4.59255 12.3213 5.09571 11.8475C5.59891 11.3739 6.47862 11.0496 7.27829 10.8882C6.47866 10.7273 5.59894 10.403 5.09547 9.92945Z"
      fill="url(#paint1_radial_982_106300)"
    />
    <defs>
      <clipPath id="paint0_diamond_982_106300_clip_path">
        <path d="M9.6896 3.43888C8.84707 2.64562 8.27039 1.26039 7.9842 0C7.69757 1.26064 7.12151 2.64617 6.27867 3.43943C5.43614 4.23214 3.96389 4.7749 2.625 5.04479C3.96443 5.31415 5.43642 5.85658 6.27894 6.64987C7.12147 7.44284 7.69815 8.82837 7.98478 10.0888C8.27097 8.82811 8.84748 7.44258 9.68987 6.64933C10.5324 5.85636 12.0047 5.31386 13.3435 5.04396C12.0044 4.77461 10.5324 4.23188 9.6896 3.43888Z" />
      </clipPath>
      <linearGradient
        id="paint0_diamond_982_106300"
        x1="0"
        y1="0"
        x2="500"
        y2="500"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AA97D8" />
        <stop offset="1" stop-color="#6442B3" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_982_106300"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-2.5124 -1.98456 1.20062 -4.15287 4.34345 10.8886)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4B3286" />
        <stop offset="1" stop-color="#18102B" />
      </radialGradient>
    </defs>
  </svg>
);

export const FormatIcon: React.FC<{ format: DeliveryFormat }> = ({
  format,
}) => {
  switch (format) {
    case "presentation":
      return PRESENTATION_ICON;
    case "pdf":
      return PDF_ICON;
    case "video":
      return VIDEO_ICON;
    case "image-set":
      return IMAGE_SET_ICON;
  }
};
